// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1074f4f0","952":"a1520f0b"}[chunkId] + ".chunk.js";
};